import React from 'react';
import PropTypes from 'prop-types';
import ChessboardDeprecated from '.';
import ChessboardItem from './item';

export default class ChessboardRenderer extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    onOpenContact: PropTypes.func,
    deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };
  render() {
    const { items, onOpenContact, deeplinkId } = this.props;
    return (
      <ChessboardDeprecated deeplinkId={deeplinkId}>
        {items.map((item, i) => (
          <ChessboardItem key={i} {...item} onOpenContact={onOpenContact} />
        ))}
      </ChessboardDeprecated>
    );
  }
}
